// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // rutaBase:"https://dev.digitalfactoring.net",
  // secret_key: "6oCgtPH8Y0FivMGlhQCkseiqA",
  // rutaBase:"https://dev.digitalfactoring.net",
  // secret_key: "6oCgtPH8Y0FivMGlhQCkseiqA",
  rutaBase:"https://api.starkengine.com",
  // rutaBase:"https://api.crowdin.la",
  secret_key: "cd2nRttcAGmIiw4WeK5MUUnbowoabW",
  ROLE_ADMIN_ID: 84,
  ROLE_RIESGO_ID: 85,
  LABEL_PROVEEDOR: "Cliente",
  LABEL_PROVEEDORES: "Clientes",
  LABEL_ADQUIRENTE: "Pagador",
  LABEL_ADQUIRENTES: "Pagadores",
  LABEL_PROSPECTO: "Prospecto",
  LABEL_PROSPECTOS: "Prospectos",
  LABEL_SIMULADOR: "Simulador",
  LABEL_PROFORMA: "Proforma",
  LABEL_PROFORMAS: "Proformas",
  LABEL_REF_BANCARIAS: "Referencias bancarias",
  ID_GUIA_SOLES: 1585,
  ID_GUIA_DOLARES: 1584,
  ID_MONEDA: 239,
  ID_BANCO: 1256,
  ID_PAGO: 1273,
  ID_TIPO_COMPROBANTEIF: 1277,
  ID_TIPO_DOC_IDENTIFICACION: 1282,
  ID_IGV_EXONERADO: 1286,
  ID_COMPROBANTE_EMITIDO: 1289,
  ID_COMPROBANTE_CONTA: 1293,
  ID_ROL_CONTACTO: 1296,
  ID_CONDICION: 1302,
  ID_TIPO_CONTACTO: 1307,
  ID_TIPO_CONFORMIDA: 1311,
  ID_TIPO_COMPROBANTE: 1316,
  ID_TIPO_EMISION: 1319,
  ID_RETENCION_FONDO: 1322,
  ID_RETENCION: 1325,
  ID_TIPO_XLS: 1328,
  ID_TIPO_PLANTILLA: 1336,
  ID_TIPO_CUENTA: 1341,
  ID_BANCO_IF: 1344,
  ID_PARTICIPANTE: 1347,
  ID_RUT: 1350,
  ID_TIPO_SOLICITUD: 1353,
  ID_TIPO_OPERACION: 1356,
  ID_TIPO_PAGOCPE: 1359,
  ID_TIPO_OPERACION_NC: 1362,
  ID_TIPO_OPERACION_ND: 1373,
  ID_TIPO_SERVICIO: 365,
  ID_TIPO_PAGARE: 1381,
  ID_TIPO_PROCESO: 1384,
  ID_TIPO_ADJUNTO: 1388,
  ID_FACTOR_REPRESENTANTE: 149,
  ID_FACTOR_DATOS: 1399,
  ID_FACTOR_BANCO: 392, //BANCO PARA COBRANZAS
  ID_TIPO_FACTURACION: 1440,
  ID_TIPO_DNI: 1283,
  ID_CARNET: 1284,
  ID_RUC: 1285,
  ID_IGV_Exonerado: 1287,
  ID_IGV_No_Exonerado: 1288,
  ID_FACTORING: 366,
  ID_CONFIRMING: 367,
  ID_DESCUENTO: 386,
  ID_DEPOSITO_BANCARIO: 1274,
  ID_PLANILLA_DE_COLOCACION: 1337,
  ID_PLANILLA_DE_REMANENTE: 1338,
  TIPO_PROCESO: {
    CONTRATO_MARCO: 1386
  },
  TIPO_PAGARE: {
    COMPLETO: 1382,
    INCOMPLETO: 1383
  },
  ID_ROL_PP: 66,
  /** Cálculo tipo Excel Servifin (ORDEN DE OPERACIÓN) */
  SERVIFIN_MODE: true,
  SERVIFIN_EMPRESA_FACTOR_IDS: [5],
  SERVIFIN_EMPRESA_NOMBRE: 'SERVIFIN S.A.S',
  SERVIFIN_EMPRESA_CIUDAD: 'Cali',
  SERVIFIN_EMPRESA_PAIS: 'Colombia',
  SERVIFIN_NOMBRE_PROYECTO: 'Servifin',
  SERVIFIN_LOGO_PATH: 'assets/img/SERVIFIN/logo_servifin.png',
  SERVIFIN_TAGLINE: 'Servicios Financieros',
  LABEL_IGV: 'IVA',
  LABEL_RUC: 'NIT',
  LABEL_DOC_IDENT: 'NIT / C.C.',
  LABEL_MONEDA_LOCAL: 'Pesos COP',
  LABEL_IMPUESTO_ENTIDAD: 'DIAN',
  SERVIFIN_COMISION_MINIMA: 430000,
  SERVIFIN_TASA_COMISION: 1.8,
  SERVIFIN_TASA_INVERSION: 19,
  SERVIFIN_PORC_GRAV: 0,
  SERVIFIN_PORC_NEG_DEFAULT: 92,
  LABEL_PORC_NEG: '% Negociado',
  LABEL_TASA_INVERSION: 'Tasa inversión (% anual)',
  LABEL_TASA_COMISION: 'Tasa comisión (%)',
  LABEL_GRAVAMEN: 'Grav. bancario (%)',
};